import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider } from "@/context/AppContext";
import { AuthProvider } from "@/context/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingHelp from "@/components/FloatingHelp";
import Assistant from "@/components/Assistant";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Temples from "@/pages/Temples";
import TempleDetail from "@/pages/TempleDetail";
import Archakas from "@/pages/Archakas";
import ArchakaDetail from "@/pages/ArchakaDetail";
import PostVacancy from "@/pages/PostVacancy";
import ArchakaRegister from "@/pages/ArchakaRegister";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Auth from "@/pages/Auth";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";

function Shell() {
  return (
    <>
      <Header />
      <main className="min-h-[60vh]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/temples" element={<Temples />} />
          <Route path="/temples/:id" element={<TempleDetail />} />
          <Route path="/archakas" element={<Archakas />} />
          <Route path="/archakas/:id" element={<ArchakaDetail />} />
          <Route path="/post-vacancy" element={<PostVacancy />} />
          <Route path="/archaka-register" element={<ProtectedRoute><ArchakaRegister /></ProtectedRoute>} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
        </Routes>
      </main>
      <Footer />
      <FloatingHelp />
      <Assistant />
    </>
  );
}

function App() {
  return (
    <AppProvider>
      <AuthProvider>
        <BrowserRouter>
          <Shell />
          <Toaster position="top-center" richColors toastOptions={{ style: { fontFamily: "'Noto Sans Telugu', 'Noto Serif Telugu', sans-serif" } }} />
        </BrowserRouter>
      </AuthProvider>
    </AppProvider>
  );
}

export default App;
